
import IftaLabel from 'primevue/iftalabel';
import Button from 'primevue/button';
import { ref } from 'vue';
import InputText from 'primevue/inputtext';
import { main_wallet } from '../apis/main_wallet';
import { useAuthStore } from '../stores/auth';
import { useToast } from 'primevue/usetoast';

export default {
	name: 'PromotionCoupon',
	components: {
		IftaLabel,
		InputText,
		Button,
	},
	setup() {
		const auth = useAuthStore();
		auth.hydrate()

		const toast = useToast();

		const form = ref({
			coupon: {
				value: '',
				invalid: false,
			},
			btn: {
				disabled: false,
				loading: false,
			}
		});

		const formSubmit = async () => {
			form.value.btn.loading = true;
			form.value.coupon.invalid = false;
			try {

				if (form.value.coupon.value === '') {
					form.value.coupon.invalid = true;
					return;
				}

				const payload = {
					recordId: form.value.coupon.value,
				}

				const resp = await main_wallet.addCouponToProduct(payload)

				if (resp.code === '8017') {
					alert(resp.message);
					await auth.logout();
					window.location.reload();
					return;
				}

				if (resp.code !== '0') throw new Error(resp.message)

				await auth.fetchData();

				toast.add({ severity: 'success', summary: resp.message, detail: 'ส่งคูปองสำเร็จ', life: 3000 });
			} catch (error) {
				toast.add({ severity: 'error', summary: 'เกิดข้อผิดพลาดบางอย่าง', detail: error, life: 3000 });
			} finally {
				form.value.btn.loading = false;
			}
		}

		return {
			form,
			formSubmit,
		}
	},
};
